import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from '@saucelabs/sl-component-loader';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Alert from '@saucelabs/sl-component-alert';
import { records as userRecords } from '@saucelabs/sl-module-user';
import { DebouncedInput } from '@saucelabs/sl-component-form';
import { Grid, Row, Col } from '@saucelabs/sl-component-grid';
import Collapse from 'react-css-collapse';
import { IconSearch } from '@saucelabs/sl-component-icons';

import MobileAppTable from '../../components/MobileAppTable';
import AppsTableEmptyState from '../../components/EmptyState/AppsTableEmptyState';
import UploadAppToggleButton from '../../components/UploadAppToggleButton';
import GeneralFilter from '../../components/GeneralFilter';
import AppUploadBox from '../../components/AppUploadBox';
import Styles from './AppsManagementContainer.styles';
import * as actions from '../../actions';
import { configuratorSelector } from '../../selectors';

class AppsManagementContainer extends Component {
  state = {
    searchTerm: '',
    isOpen: false,
  };

  componentDidMount() {
    const { getMobileAppsInitialData, apps, user } = this.props;
    const appsData = apps.get('items').toArray();

    if (!appsData.length) {
      getMobileAppsInitialData({ user });
    }
  }

  handleSearch = (searchTerm) => {
    const { getMobileAppsInitialData, user, apps } = this.props;
    getMobileAppsInitialData({
      user,
      searchTerm,
      osFilters: apps.getIn(['filter', 'selectedItems']).toArray(),
    });
    this.setState({ searchTerm });
  }

  handleOsFilter = ({ items }) => {
    const { setOsFilter, getMobileAppsInitialData, user } = this.props;
    const { searchTerm } = this.state;
    setOsFilter({ items });
    getMobileAppsInitialData({ user, searchTerm, osFilters: items.toArray() });
  }

  onUploadClick = (isOpen) => {
    this.setState({ isOpen });
  }

  render() {
    const {
      apps,
      appItems,
      uploadingItems,
      meta,
      handleAppClick,
      uploadApp,
      uploadAppCancel,
    } = this.props;
    const { isOpen } = this.state;

    return (
      <>
        <h1 className={Styles.title}>Select an App</h1>
        <Grid className={Styles.grid}>
          {meta.error && meta.submitFailed && <Alert bsStyle="danger">You have to choose an App</Alert>}
          <Row
            className={Styles.controls}
            middle="xs"
          >
            <Col xs={4}>
              <DebouncedInput
                debounceMs={500}
                formStyles={Styles.form}
                handleChange={this.handleSearch}
                Icon={<IconSearch className={Styles.icon} />}
                minWidth={2}
                placeholder="Type to search..."
                type="text"
              />
            </Col>
            <Col xs={2}>
              <GeneralFilter
                filter={apps.get('filter')}
                filterKey="os"
                onSelectFilter={this.handleOsFilter}
              />
            </Col>
            <Col
              className={Styles['button-wrapper']}
              xs={6}
            >
              <UploadAppToggleButton
                isOpen={isOpen}
                onUploadClick={this.onUploadClick}
              />
            </Col>
          </Row>
          <Collapse
            isOpen={isOpen}
            transition="height 250ms cubic-bezier(.4, 0, .2, 1)"
          >
            <Row
              center="xs"
              className={Styles['upload-row']}
            >
              <Col
                className={Styles['upload-column']}
                xs={6}
              >
                <div className={Styles['upload-wrapper']}>
                  <AppUploadBox
                    onSelectFile={uploadApp}
                    onUploadClick={this.onUploadClick}
                  />
                </div>
              </Col>
            </Row>
          </Collapse>
          <Loader
            fontSize={3}
            show={apps.get('loading')}
          >
            {appItems.length || uploadingItems.length ? (
              <MobileAppTable
                apps={appItems}
                appsUploading={uploadingItems}
                onClick={handleAppClick}
                uploadAppCancel={uploadAppCancel}
              />
            ) : (
              <AppsTableEmptyState
                isOpen={isOpen}
                onUploadClick={this.onUploadClick}
              />
            )}
          </Loader>
        </Grid>
      </>
    );
  }
}

AppsManagementContainer.propTypes = {
  appItems: PropTypes.array.isRequired,
  apps: PropTypes.object.isRequired,
  getMobileAppsInitialData: PropTypes.func.isRequired,
  handleAppClick: PropTypes.func.isRequired,
  meta: PropTypes.object.isRequired,
  setOsFilter: PropTypes.func.isRequired,
  uploadApp: PropTypes.func.isRequired,
  uploadAppCancel: PropTypes.func.isRequired,
  uploadingItems: PropTypes.array.isRequired,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass).isRequired,
};

const mapStateToProps = (state) => ({
  apps: state.apps.manual.apps,
  appItems: configuratorSelector(state).appItems,
  uploadingItems: configuratorSelector(state).uploadingItems,
  user: state.user,
});

const mapDispatchToProps = {
  getMobileAppsInitialData: actions.getMobileAppsInitialData,
  uploadApp: actions.uploadApp,
  uploadAppCancel: actions.uploadAppCancel,
  setOsFilter: actions.setFilterItems,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppsManagementContainer);
export { AppsManagementContainer, mapStateToProps, mapDispatchToProps };
